import { useState, useEffect, useCallback } from "react";
import useFetchWithMsal from "../../../hooks/useFetchWithMsal";
import { protectedResources } from "../../../authConfig";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const useBaskets = () => {
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });

  const [baskets, setBaskets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const showSnackbar = (message, severity = "success") =>
    setSnackbar({ open: true, message, severity });

  const fetchBaskets = useCallback(async () => {
    setLoading(true);
    try {
      const data = await execute("GET", `${BASE_URL}/api/tradeDelay/baskets`);
      setBaskets(data || []);
    } catch {
      showSnackbar("שגיאה בטעינת הסלים", "error");
    } finally {
      setLoading(false);
    }
  }, [execute]);

  const createBasket = async (basketData) => {
    const data = await execute("POST", `${BASE_URL}/api/tradeDelay/baskets`, basketData);
    showSnackbar("הסל נוצר בהצלחה");
    await fetchBaskets();
    return data;
  };

  const updateBasket = async (id, basketData) => {
    const data = await execute("PUT", `${BASE_URL}/api/tradeDelay/baskets/${id}`, basketData);
    showSnackbar("הסל עודכן בהצלחה");
    await fetchBaskets();
    return data;
  };

  const deleteBasket = async (id) => {
    await execute("DELETE", `${BASE_URL}/api/tradeDelay/baskets/${id}`);
    showSnackbar("הסל נמחק בהצלחה");
    await fetchBaskets();
  };

  useEffect(() => {
    fetchBaskets();
  }, [fetchBaskets]);

  return { baskets, loading, snackbar, setSnackbar, createBasket, updateBasket, deleteBasket };
};

export default useBaskets;
